/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    reference: string;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof Invoice
     */
    date: ShiftiePlainDate | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    totalDue: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    subTotal: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    vatValue: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    status: InvoiceStatusEnum | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    url: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Invoice
     */
    urlIsRefreshable: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    urlLastKnownRefreshDateTime: Date | null;
}

/**
* @export
* @enum {string}
*/
export enum InvoiceStatusEnum {
    Failed = 'Failed',
    Paid = 'Paid',
    Pending = 'Pending',
    Void = 'Void'
}


/**
 * Check if a given object implements the Invoice interface.
 */
export function instanceOfInvoice(value: object): value is Invoice {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('reference' in value) || value['reference'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('totalDue' in value) || value['totalDue'] === undefined) return false;
    if (!('subTotal' in value) || value['subTotal'] === undefined) return false;
    if (!('vatValue' in value) || value['vatValue'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('urlIsRefreshable' in value) || value['urlIsRefreshable'] === undefined) return false;
    if (!('urlLastKnownRefreshDateTime' in value) || value['urlLastKnownRefreshDateTime'] === undefined) return false;
    return true;
}

export function InvoiceFromJSON(json: any): Invoice {
    return InvoiceFromJSONTyped(json, false);
}

export function InvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Invoice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'reference': json['reference'],
        'date': ShiftiePlainDateFromJSON(json['date']),
        'totalDue': json['totalDue'],
        'subTotal': json['subTotal'],
        'vatValue': json['vatValue'],
        'status': json['status'],
        'url': json['url'],
        'urlIsRefreshable': json['urlIsRefreshable'],
        'urlLastKnownRefreshDateTime': (json['urlLastKnownRefreshDateTime'] == null ? null : new Date(json['urlLastKnownRefreshDateTime'])),
    };
}

  export function InvoiceToJSON(json: any): Invoice {
      return InvoiceToJSONTyped(json, false);
  }

  export function InvoiceToJSONTyped(value?: Invoice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'reference': value['reference'],
        'date': ShiftiePlainDateToJSON(value['date']),
        'totalDue': value['totalDue'],
        'subTotal': value['subTotal'],
        'vatValue': value['vatValue'],
        'status': value['status'],
        'url': value['url'],
        'urlIsRefreshable': value['urlIsRefreshable'],
        'urlLastKnownRefreshDateTime': (value['urlLastKnownRefreshDateTime'] == null ? null : (value['urlLastKnownRefreshDateTime'] as any).toISOString()),
    };
}

